import React, { useEffect, useState } from "react"
import { CardBody, Col, Form, FormGroup, Label, Row } from "reactstrap"
import { useFormik } from "formik"
import { useSelector } from "react-redux"

import { Button } from "components/Button"
import { TextInput } from "components/TextInput"
import { initialValues, validationSchema } from "./FormConfig"
import { AutoComplete } from "components/AutoComplete"
import { Modal } from "components/Modal"
import { MANAGER_ROLES, UserRoles, UserTypes } from "../../../../constants"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"
import { isUserInRoles } from "utils/commonUtils"

const USER_ROLE_OPTIONS = [
   {
      label: "Executive",
      value: UserRoles.Executive,
   },

   {
      label: "Department Manager",
      value: UserRoles.Department,
   },
   {
      label: "Plant Manager",
      value: UserRoles.PlantManager,
   },
   {
      label: "Asst. Plant Manager",
      value: UserRoles.AssistantPlantManager,
   },
   {
      label: "Finance Manager",
      value: UserRoles.Finance,
   },
   {
      label: "Warehouse Manager",
      value: UserRoles.Warehouse,
   },
   {
      label: "Marketing Manager",
      value: UserRoles.Marketing,
   },
]

const AddEditUser = ({
   attachedUsers = [],
   firstName = "",
   lastName = "",
   emailAddress = "",
   role = "",
   departmentName = "",
   btnText = "",
   isAddUser = false,
   isEditUser = false,
   loading = false,
   onSubmitForm = () => {},
}) => {
   const { userAuth } = useSelector(state => state)
   const isPlantManager = userAuth?.user?.type === UserTypes.PLANT_MANAGER
   const isManagerRole = MANAGER_ROLES.includes(userAuth?.user?.type)

   const [selectedRole, setSelectedRole] = useState("")
   const [selectedRoleTemp, setSelectedRoleTemp] = useState("")
   const [validationModalToggle, setValidationModalToggle] = useState(false)

   let plantManagerOptions = USER_ROLE_OPTIONS.filter(
      item => item.value == UserRoles.AssistantPlantManager
   )

   useEffect(() => {
      if (isManagerRole && isAddUser) {
         const asstManagerRole = USER_ROLE_OPTIONS.find(
            item => item.value === UserRoles.AssistantPlantManager
         )
         setSelectedRole(asstManagerRole)
         setSelectedRoleTemp(asstManagerRole)
         formik.setFieldValue("role", UserRoles.AssistantPlantManager)
      }
   }, [isManagerRole, isAddUser])

   useEffect(() => {
      let obj = USER_ROLE_OPTIONS.find(item => item.value == role)
      if (isEditUser) {
         formik.setFieldValue("firstName", firstName)
         formik.setFieldValue("lastName", lastName)
         formik.setFieldValue("emailAddress", emailAddress)
         formik.setFieldValue("role", role)
         setSelectedRole({
            ...obj,
         })
         formik.setFieldValue("departmentName", departmentName)
      }

      return () => {
         formik.setFieldValue("firstName", "")
         formik.setFieldValue("lastName", "")
         formik.setFieldValue("emailAddress", "")
         formik.setFieldValue("role", "")
         formik.setFieldValue("departmentName", "")
      }
   }, [])

   const formik = useFormik({
      enableReinitialize: true,
      initialValues,
      validationSchema,
      onSubmit: values => {
         handleAddEditUserSubmit(values)
      },
   })

   const handleSelectRoleInit = option => {
      setSelectedRoleTemp(option)
      if (attachedUsers.length && option.value != role) {
         setValidationModalToggle(true)
      } else {
         if (option.value !== UserRoles.Department) {
            formik.setFieldValue("departmentName", null)
         }
         formik.setFieldValue("role", option.value)
         setSelectedRole(option)
      }
   }

   const handleSelectRole = () => {
      formik.setFieldValue("role", selectedRoleTemp.value)
      setSelectedRole(selectedRoleTemp)
   }

   const handleContinueChangeRole = () => {
      handleSelectRole()
      setValidationModalToggle(false)
   }

   const handleAddEditUserSubmit = values => {
      onSubmitForm(values)
   }

   return (
      <>
         <Form onSubmit={formik.handleSubmit}>
            <CardBody className="user-add-edit-card-container shadow-none">
               <FormGroup className="d-flex user-validation-handler">
                  <Label
                     for="first name"
                     className="user-mang-modal-label "
                     sm={4}
                  >
                     First Name
                  </Label>
                  <Col sm={7} className="input-text-container ">
                     <TextInput
                        className="user-mang-modal-input "
                        type="first name"
                        name="firstName"
                        id="first name"
                        placeholder="Type first name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.firstName}
                     />
                  </Col>
               </FormGroup>

               <Row className="mb-3 input-text-warnings">
                  <Col sm={4}></Col>
                  <Col sm={7}>
                     {formik.touched.firstName && formik.errors.firstName ? (
                        <span className="error fs-14">
                           {formik.errors.firstName}
                        </span>
                     ) : null}
                  </Col>
               </Row>

               <FormGroup className="d-flex user-validation-handler">
                  <Label
                     for="last name"
                     className="user-mang-modal-label "
                     sm={4}
                  >
                     Last Name
                  </Label>
                  <Col sm={7} className="input-text-container ">
                     <TextInput
                        className="user-mang-modal-input "
                        type="last name"
                        name="lastName"
                        id="last name"
                        placeholder="Type Last Name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.lastName}
                     />
                  </Col>
               </FormGroup>

               <Row className="mb-3 input-text-warnings">
                  <Col sm={4}></Col>
                  <Col sm={7}>
                     {formik.touched.lastName && formik.errors.lastName ? (
                        <span className="error fs-14">
                           {formik.errors.lastName}
                        </span>
                     ) : null}
                  </Col>
               </Row>
               <FormGroup className="d-flex user-validation-handler">
                  <Label
                     for="email address"
                     className="user-mang-modal-label"
                     sm={4}
                  >
                     Email Address
                  </Label>
                  <Col sm={7} className="input-text-container ">
                     <TextInput
                        className="user-mang-modal-input "
                        type="email address"
                        name="emailAddress"
                        id="email address"
                        placeholder="Type Email Address"
                        invalid={
                           formik.touched.confirmPassword &&
                           !!formik.errors.confirmPassword
                        }
                        valid={
                           formik.touched.confirmPassword &&
                           !formik.errors.confirmPassword
                        }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.emailAddress}
                        disabled={isEditUser}
                     />
                  </Col>
               </FormGroup>

               <Row className="mb-3 input-text-warnings">
                  <Col sm={4}></Col>
                  <Col sm={7}>
                     {formik.touched.emailAddress &&
                     formik.errors.emailAddress ? (
                        <span className="error fs-14">
                           {formik.errors.emailAddress}
                        </span>
                     ) : null}
                  </Col>
               </Row>

               <FormGroup className="d-flex user-validation-handler">
                  <Label for="role" className="user-mang-modal-label" sm={4}>
                     Role
                  </Label>
                  <Col sm={7} className="input-text-container ">
                     <AutoComplete
                        placeholder="Select Role"
                        classNamePrefix="add-new-req"
                        customStyles={autoCompleteStyles.STYLE_FOUR}
                        options={
                           isPlantManager
                              ? plantManagerOptions
                              : USER_ROLE_OPTIONS
                        }
                        onChange={handleSelectRoleInit}
                        value={selectedRole}
                        isSearchable={false}
                        isDisabled={isUserInRoles(
                           userAuth?.user?.type,
                           MANAGER_ROLES
                        )}
                     />
                  </Col>
               </FormGroup>

               <Row className="mb-3 input-text-warnings">
                  <Col sm={4}></Col>
                  <Col sm={7}>
                     {formik.touched.role && formik.errors.role ? (
                        <span className="error fs-14">
                           {formik.errors.role}
                        </span>
                     ) : null}
                  </Col>
               </Row>

               {formik.values.role == UserRoles.Department && (
                  <div>
                     <FormGroup className="d-flex user-validation-handler">
                        <Label
                           for="first name"
                           className="user-mang-modal-label "
                           sm={4}
                        >
                           Department Name
                        </Label>
                        <Col sm={7} className="input-text-container ">
                           <TextInput
                              className="user-mang-modal-input "
                              type="Department Name"
                              name="departmentName"
                              id="department name"
                              placeholder="Type department name"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.departmentName}
                           />
                        </Col>
                     </FormGroup>

                     <Row className="mb-3 input-text-warnings">
                        <Col sm={4}></Col>
                        <Col sm={7}>
                           {formik.touched.departmentName &&
                           formik.errors.departmentName ? (
                              <span className="error fs-14">
                                 {formik.errors.departmentName}
                              </span>
                           ) : null}
                        </Col>
                     </Row>
                  </div>
               )}

               <Button
                  type="submit"
                  title={btnText}
                  className="gt-btn-grad-primary mt-5 button-width-container"
                  isLoading={loading}
               />
            </CardBody>
         </Form>

         <Modal
            isOpen={validationModalToggle}
            handleModalToggling={() => setValidationModalToggle(prev => !prev)}
            bodyClassName="p-0"
            customButton={true}
            hideModalHeaderSeparator={true}
            headerClasses="modal-header-container"
            sizeClasses={"2"}
            modalTitle={"Change Role"}
         >
            <div className="mb-4 mt-4 d-flex flex-column align-items-center">
               <h4 className="text-center font-bold">
                  Are you sure you want to change this user's role ?
               </h4>
               <p className="text-center">
                  {`This user is a ${UserRoles.getDisplayTextKey(role)}
                            of the following`}
               </p>
               <div>
                  <ol className="m-0 p-0 pt-2">
                     {attachedUsers.map((item, index) => (
                        <li key={index}>
                           {role == UserRoles.Department
                              ? item.department.departmentName
                              : item.warehouse.warehouseName}
                        </li>
                     ))}
                  </ol>
               </div>

               <div className="d-flex justify-content-center mt-5">
                  <Button
                     type=""
                     title="Cancel"
                     className="location-modal-cancel-btn"
                     onClick={() => setValidationModalToggle(prev => !prev)}
                  />

                  <Button
                     type=""
                     title="Continue"
                     className="gt-btn-grad-primary location-modal-del-btn"
                     onClick={handleContinueChangeRole}
                  />
               </div>
            </div>
         </Modal>
      </>
   )
}

export default AddEditUser
